import { render, staticRenderFns } from "./ScheduledReparationDateQuestion.vue?vue&type=template&id=20524c92&scoped=true"
import script from "./ScheduledReparationDateQuestion.vue?vue&type=script&lang=ts"
export * from "./ScheduledReparationDateQuestion.vue?vue&type=script&lang=ts"
import style0 from "./ScheduledReparationDateQuestion.vue?vue&type=style&index=0&id=20524c92&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20524c92",
  null
  
)

export default component.exports